import React from 'react';

function Cta() {
  return <div>Call to action</div>;
}

export default Cta;
